var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#0f8560}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    transform: "translate(-263 -599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(263 599)",
    style: {
      stroke: "#0f8560",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    style: {
      fill: "none"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support",
    transform: "translate(273.71 613.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    className: "cls-2",
    d: "M88.6 41.206H73.99a1.584 1.584 0 0 0-1.578 1.578v9.08a1.584 1.584 0 0 0 1.578 1.578h10.074l2.28 2.3a.488.488 0 0 0 .351.156.5.5 0 0 0 .507-.507v-1.949h1.4a1.584 1.584 0 0 0 1.578-1.578v-9.08a1.584 1.584 0 0 0-1.58-1.578zm-12.369 7.813a1.461 1.461 0 1 1 1.461-1.461 1.472 1.472 0 0 1-1.461 1.461zm5.125 0a1.461 1.461 0 1 1 1.461-1.461 1.472 1.472 0 0 1-1.461 1.461zm5.105 0a1.461 1.461 0 1 1 1.461-1.461 1.472 1.472 0 0 1-1.461 1.461z",
    transform: "translate(-68.885 -41.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    className: "cls-2",
    d: "M2.631 200.3v-3.1h-1.6A1.04 1.04 0 0 0 0 198.239v5.961a1.025 1.025 0 0 0 1.033 1.072h.916v1.286a.341.341 0 0 0 .331.331.323.323 0 0 0 .234-.1l1.5-1.5h6.625a1.04 1.04 0 0 0 1.033-1.033v-1.481H5.106a2.478 2.478 0 0 1-2.475-2.475z",
    transform: "translate(0 -189.607)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1bc14de6.svg";
export { ForwardRef as ReactComponent };